import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type PublicEnvironment = {
  NODE_ENV: string | undefined;
  API_URL: string;
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;

  // Sentry configuration
  SENTRY_DSN: string | undefined;
  SENTRY_ENVIRONMENT: string | undefined;
  SENTRY_TRACES_SAMPLE_RATE: number | undefined;
};

declare global {
  interface Window {
    ENV: PublicEnvironment;
  }
}
